import {
  GeneralModule,
  InsuranceModule,
  PostFormAction,
  ModalOpenAction,
  GetDataAction,
  ContactDetailsModule,
  SpecialAssistanceModule,
  SportsEquipmentsModule,
  MusicalInstrumentsModule,
  PetPassengersModule,
  ItineraryChangeModule,
  RefundModule,
  FareTypesModule,
  BookingLockedModule,
} from "./constants/trackingEvents"
import type { TrackingModule, TrackingAction } from "./constants/trackingEventTypes"
import { ACTIONS as BOOKING_ACTIONS } from "../../consts/booking"
import {
  LOAD,
  SET_MODAL_OPEN,
} from "../../scenes/AccountBooking/components/Booking/services/consts"
import {
  NON_US_AXA_INSURANCE_REFUND,
  SUBMIT as INSURANCE_SUBMIT,
  US_INSURANCE_REFUND,
} from "../../scenes/AccountBooking/components/Booking/services/bookingInsurance/consts"
import { SPECIAL_ASSISTANCE_SUBMIT } from "../../scenes/AccountBooking/components/Booking/scenes/BookingAdditionalServices/scenes/SpecialAssistance/consts/actions"
import { SPORTS_EQUIPMENT_SUBMIT } from "../../scenes/AccountBooking/components/Booking/scenes/BookingAdditionalServices/scenes/SportsEquipment/consts/actions"
import { MUSICAL_EQUIPMENT_SUBMIT } from "../../scenes/AccountBooking/components/Booking/scenes/BookingAdditionalServices/scenes/MusicalEquipment/consts/actions"
import { PETS_SUBMIT } from "../../scenes/AccountBooking/components/Booking/scenes/BookingAdditionalServices/scenes/Pets/consts/actions"
import { CONFIRM as ITINERARY_CHANGE_SUBMIT } from "../../scenes/AccountBooking/components/Booking/services/changeFlights/consts"
import { GET_FARE_TYPE_RULES } from "../../scenes/AccountBooking/components/Booking/services/fareType/services/consts"
import { GET_BOOKING_LOCKED_CREDENTIALS } from "../../scenes/AccountBooking/components/BookingLocked/services/bookingLockedDuck"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
export const ActionTypeToEventDictionary: {
  [key: string]: {
    module: TrackingModule
    action: TrackingAction
    detail?: string
  }
} = {
  [INSURANCE_SUBMIT]: { module: InsuranceModule, action: PostFormAction },
  [SET_MODAL_OPEN]: { module: GeneralModule, action: ModalOpenAction },
  [BOOKING_ACTIONS.ADDITIONAL_CONTACTS]: {
    module: ContactDetailsModule,
    action: PostFormAction,
  },
  [SPECIAL_ASSISTANCE_SUBMIT]: {
    module: SpecialAssistanceModule,
    action: PostFormAction,
  },
  [SPORTS_EQUIPMENT_SUBMIT]: {
    module: SportsEquipmentsModule,
    action: PostFormAction,
  },
  [MUSICAL_EQUIPMENT_SUBMIT]: {
    module: MusicalInstrumentsModule,
    action: PostFormAction,
  },
  [PETS_SUBMIT]: { module: PetPassengersModule, action: PostFormAction },
  [ITINERARY_CHANGE_SUBMIT]: {
    module: ItineraryChangeModule,
    action: PostFormAction,
  },
  [GET_FARE_TYPE_RULES]: {
    module: FareTypesModule,
    action: GetDataAction,
  },
  [LOAD]: {
    module: GeneralModule,
    action: GetDataAction,
    detail: "Load Booking",
  },
  [BOOKING_ACTIONS.CANCEL_BOOKING]: {
    module: RefundModule,
    action: PostFormAction,
    detail: "Cancel Booking",
  },
  [GET_BOOKING_LOCKED_CREDENTIALS]: {
    module: BookingLockedModule,
    action: GetDataAction,
  },
  [NON_US_AXA_INSURANCE_REFUND]: {
    module: RefundModule,
    action: PostFormAction,
    detail: "AXA insurance",
  },
  [US_INSURANCE_REFUND]: {
    module: RefundModule,
    action: PostFormAction,
    detail: "AXA US insurance",
  },
}

export type TrackedEventTypes = keyof typeof ActionTypeToEventDictionary

export const getTrackingEventFromAction = (action: {
  type: TrackedEventTypes | string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  original_type: string
  _track?: {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value?: any
    event: string
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  res?: any
}):
  | {
      module: TrackingModule
      action: TrackingAction
      detail?: string
    }
  | null
  | undefined => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ActionTypeToEventDictionary[action.type]) {
    return ActionTypeToEventDictionary[action.type]
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ActionTypeToEventDictionary[action.original_type]) {
    return ActionTypeToEventDictionary[action.original_type]
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (action.action && ActionTypeToEventDictionary[action.action]) {
    return ActionTypeToEventDictionary[action.action]
  }

  return null
}
